import './Background.css'

const Background = () => {
  return (
    <div className='absolute bg-white w-full h-full z-[-1] overflow-hidden'>
      <div className='blob1' />
      <div className='blob2' />
      <div className='blob3' />
      <div className='blob4' />
      <div className='blob8' />
      <div className='blob9' />
      <div className='blob10' />
      <div className='blob11' />
      <div className='blob7' />
    </div>
  )
}

export default Background
